var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCartV3 = function SvgCartV3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.405 8.073L5.39 6.867a6 6 0 011.383-3.85A5.799 5.799 0 0110.276.999a5.399 5.399 0 012.264.228 5.471 5.471 0 011.98 1.143 5.594 5.594 0 011.355 1.862c.32.71.49 1.48.5 2.262l.02 1.716M19.818 20.367h0l-.001.013c-.123 1.173-.383 2.05-1.043 2.663-.662.617-1.88 1.105-4.255 1.105H7.195c-2.374 0-3.592-.488-4.255-1.105-.659-.613-.919-1.49-1.042-2.663h0l-.002-.013L.98 12.91c-.157-1.458 0-2.572.624-3.329.615-.745 1.855-1.344 4.37-1.344h9.766c2.515 0 3.755.6 4.37 1.344.624.757.781 1.87.623 3.329l-.915 7.457z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.127 12.461h.008M6.579 12.461h.008",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/CartV3.77ef1916.svg";
export { SvgCartV3 as ReactComponent };